import { toast } from "react-toastify";
import { RepositoryFactory } from "repository/RepositoryFactory";

const resolution = RepositoryFactory.get("resolution");

export const getResolutions = (page, limit) => async (dispatch) => {
  try {
    dispatch({ type: "GET_RESOLUTION_LOADER", payload: true });
    const { data } = await resolution.getResolutionTeam(page, limit);

    dispatch({
      type: "GET_RESOLUTION_TEAMS",
      payload: data.data,
    });
    dispatch({ type: "GET_RESOLUTION_LOADER", payload: false });
  } catch (err) {
    toast.error(err.response.data.message);

    dispatch({ type: "GET_RESOLUTION_LOADER", payload: false });
  }
};

export const resolutionSearchByName = (name) => async (dispatch) => {
  try {
    dispatch({
      type: "GET_RESOLUTION_LOADER",
      payload: true,
    });
    const { data } = await resolution.resolutionSearchByName(name);
    console.log('resolutionSearchByName_data: ', data);
      dispatch({
        type: "GET_RESOLUTION_BY_NAME",
        payload: data.data,
      });
      dispatch({
        type: "GET_RESOLUTION_LOADER",
        payload: false,
      });

  } catch (error) {
    // toast.error(error.response.data.message);
    dispatch({
      type: "GET_RESOLUTION_LOADER",
      payload: false,
    });
  }
};

export const deleteResolution =
  (id, onSuccess = () => {}) =>
  async (dispatch) => {
    try {
      dispatch({
        type: "DELETE_RESOLUTION_LOADER",
        payload: true,
      });
      const { data } = await resolution.deleteResolutionTeam(id);

      dispatch({
        type: "DELETE_RESOLUTION_LOADER",
        payload: false,
      });

      toast.success(data?.message);
      if (data?.success) {
        dispatch({
          type: "RESOLUTION_TEAM_DELETED",
          payload: id,
        });
      }
      onSuccess();
    } catch (err) {
      toast.error(err.response.data.message);

      dispatch({
        type: "DELETE_RESOLUTION_LOADER",
        payload: false,
      });
    }
  };
export const addResolution =
  (payload, onSuccess = () => {}) =>
  async (dispatch) => {
    try {
      dispatch({
        type: "ADD_RESOLUTION_LOADER",
        payload: true,
      });

      const { data } = await resolution.addResolutionTeam(payload);

      toast.success(data?.message);
      onSuccess();
      dispatch({
        type: "ADD_RESOLUTION_LOADER",
        payload: false,
      });
      //   if (data?.success) {
      //     dispatch({
      //       type: "RESOLUTION_TEAM_ADDED",
      //       payload: payload,
      //     });
      //   }
    } catch (err) {
      toast.error(err.response.data.message);

      dispatch({
        type: "ADD_RESOLUTION_LOADER",
        payload: false,
      });
    }
  };

export const updateResolution =
  (id, payload, onSuccess = () => {}) =>
  async (dispatch) => {
    console.log("id, payload: ", id, payload);
    try {
      dispatch({
        type: "UPDATE_RESOLUTION_LOADER",
        payload: true,
      });

      const { data } = await resolution.updateResolutionTeam(id, payload);

      toast.success(data?.message);
      onSuccess();
      dispatch({
        type: "UPDATE_RESOLUTION_LOADER",
        payload: false,
      });
    } catch (err) {
      toast.error(err.response.data.message);

      dispatch({
        type: "UPDATE_RESOLUTION_LOADER",
        payload: false,
      });
    }
  };
